import React, { useState } from 'react';
const PercentageCalculator = ({ percentage }) => {
  const [value1, setValue1] = useState(percentage);
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');
  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('Please enter both values correctly');
      setResult('');
      setExplanation('');
      return;
    }
    const percentage = parseFloat(value1);
    const ofValue = parseFloat(value2);
    const calculatedResult = (percentage / 100) * ofValue;
    setResult(calculatedResult.toFixed(2));
    setExplanation(
      `${value1}% of ${value2} = (${value1}/100) * ${value2} = ${percentage / 100
      } * ${ofValue} = ${calculatedResult.toFixed(2)}`
    );
    setError('');
  };
  return (
    <div dir="rtl">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="number"
          placeholder={value1}
          value={value1}
          onChange={(e) => setValue1(e.target.value)}
          className="form-control ml-2"
          style={{ width: '80px' }}
        />
        <span>% of </span>
        <input
          type="number"
          placeholder="value"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          className="form-control ml-2"
          style={{ width: '120px', marginLeft: '5px', marginRight: '5px' }}
        />
        <button
          className="btn btn-success"
          style={{ fontSize: '20px' }}
          onClick={handleCalculate}
        >
          Calculate        </button>
      </div>
      <br />
      <div>
        {error !== '' ? (
          <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
        ) : (
          <>
            {result !== '' &&  (
              <>
                <p className='p-3 mb-2 bg-success text-white'>
                  Result: {value1}% of {value2} = {result}
                </p>
                {explanation !== '' && (
                  <p className='p-3 mb-2 bg-info text-black'>
                    Steps: <br />{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default PercentageCalculator;
